import { TNavigationLinkType } from '../../types';

export interface ISetNavigationLink {
  type: 'ISetNavigationLink';
  link: TNavigationLinkType;
}

export interface ISetNavigationMenuVisibility {
  type: 'ISetNavigationMenuVisibility';
  isMenuVisible: boolean;
}

export function setNavigationLink(link: TNavigationLinkType): ISetNavigationLink {
  return {
    link,
    type: 'ISetNavigationLink',
  };
}

export function setNavigationMenuVisibility(isMenuVisible: boolean): ISetNavigationMenuVisibility {
  return {
    isMenuVisible,
    type: 'ISetNavigationMenuVisibility',
  };
}
